import React, { useState, useEffect } from "react";
import { getSubscription, logInDetails } from "../../api/api";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import "../pages/search.css";

const SubReport = (props) => {
  const [search, setSearch] = useState(false);
  const [searchOn, setSearchOn] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState([]);
  const [myArray, setMyArray] = useState([]);
  const [number, setNumber] = useState(0);
  const [time, setTime] = useState("");
  const [subs, setSubs] = useState([]);
  const [sub, setSub] = useState([]);

  useEffect(() => {
    const elementDetail = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */
      const result = await getSubscription().then(
        (result) => {
          setSub(result.data);
          setLoading(false);
        },
        (error) => {
          // const obj = {'status':error.response.data.error.status, 'message':error.response.data.error.message};
          // setSubCount(obj.message);
          // setSubStatus(obj.status);
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };

    const subDetail = async () => {
      /* eslint-disable no-unused-vars */
      // const pageid = props.match.params.id;
      const result = await logInDetails(
        number,
        search,
        selectedUser,
        myArray,
        time,
        sub.SRMSecret,
        sub.uuid
      ).then(
        (result) => {
          setSubs(result.data.collection);
        },
        (error) => {
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */

      setLoading(false);
    };
    /* eslint-disable no-unused-vars */

    elementDetail();

    /* eslint-disable no-unused-vars */
    if (sub.SRMSecret && sub.uuid) subDetail();

    // eslint-disable-line react-hooks/exhaustive-deps
    //eslint-disable-next-line
  }, [number, search, time, sub.SRMSecret, sub.uuid]);

  function formatDate(string) {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(string).toLocaleDateString([], options);
  }

  const update = () => {
    setLoading(true);
    setTime(null);
  };
  const mUpdate = () => {
    setLoading(true);
    setTime("recurrent");
  };
  const tMUpdate = () => {
    setLoading(true);
    setTime("charge");
  };
  //      const lUpdate = ()=>{
  //         setLoading(true);
  //         setTime('Last Quarter');
  //          }
  //          const mTDUpdate = ()=>{
  //             setLoading(true);
  //             setTime('Month To Date');
  //              }
  //              const TUpdate = ()=>{
  //                 setLoading(true);
  //                 setTime('Today');
  //                  }
  //                  const yUpdate = ()=>{
  //                     setLoading(true);
  //                     setTime('Yesterday');
  //                      }
  const addNumber = async () => {
    let i = number + 1;
    setNumber(i);
    setLoading(true);
  };
  const minusNumber = async () => {
    let i = number - 1;
    setNumber(i);
    setLoading(true);
  };

  if (loading || subs.length === 0) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card ">
                <div className="card-header filter">
                  <h3 className="card-title">Subscription report</h3>

                  <ul className="navbar-nav ml-auto ">
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-widget="navbar-search"
                        href="#!"
                        role="button"
                        onClick={(event) => {
                          event.preventDefault();
                          setSearchOn(!searchOn);
                        }}
                      >
                        <i className="fas fa-search"></i>
                      </a>
                      <div
                        className={
                          searchOn && sub.SRMSecret && sub.uuid
                            ? "navbar-search-block"
                            : "navbar-search-block none"
                        }
                      >
                        <form
                          className="form-inline"
                          onSubmit={(event) => {
                            event.preventDefault();
                            setSearch(true);
                            // setTime('');
                            setLoading(true);
                          }}
                        >
                          <div className="input-group input-group-sm">
                            <label>From</label>&nbsp;
                            <input
                              className="form-control form-control-navbar"
                              type="search"
                              placeholder="yyyy-mm-dd"
                              aria-label="yyyy-mm-dd"
                              value={selectedUser}
                              onChange={(event) => {
                                setSelectedUser(event.target.value);
                                setSearch(false);
                              }}
                            />
                            &nbsp;&nbsp;
                            <label>To</label>&nbsp;
                            <input
                              className="form-control form-control-navbar"
                              type="search"
                              placeholder="yyyy-mm-dd"
                              aria-label="yyyy-mm-dd"
                              value={myArray}
                              onChange={(event) => {
                                setMyArray(event.target.value);
                                setSearch(false);
                              }}
                            />
                            <div className="input-group-append">
                              <button className="btn btn-navbar" type="submit">
                                <i className="fas fa-search"></i>
                              </button>
                              <button
                                className="btn btn-navbar"
                                type="button"
                                data-widget="navbar-search"
                                onClick={(event) => {
                                  event.preventDefault();
                                  setSearch(false);
                                  setSearchOn(false);
                                }}
                              >
                                <i className="fas fa-times"></i>
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </li>
                    <li>
                      <div className="btn-group">
                        <button type="button" className="btn btn-default">
                          {time ? time : "Type"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-default dropdown-toggle dropdown-icon"
                          data-toggle="dropdown"
                          aria-expanded="false"
                          disabled={sub.SRMSecret && sub.uuid ? false : true}
                        >
                          <span className="sr-only">Toggle Dropdown</span>
                        </button>
                        <div className="dropdown-menu" role="menu">
                          <button
                            className="dropdown-item"
                            name="type"
                            onClick={update}
                          >
                            All
                          </button>
                          <button className="dropdown-item" onClick={mUpdate}>
                            Recurrent
                          </button>
                          <button className="dropdown-item" onClick={tMUpdate}>
                            Charge
                          </button>
                          {/* <button
                                            className="dropdown-item"
                                            onClick={lUpdate}
                                            >
                                              Last Quarter
                                            </button>
                                            <button
                                            className="dropdown-item"
                                            onClick={mTDUpdate}
                                            >
                                              Month to Date
                                            </button>
                                            <button
                                            className="dropdown-item"
                                            onClick={TUpdate}
                                            >
                                              Today
                                            </button>
                                            <button
                                            className="dropdown-item"
                                            onClick={yUpdate}
                                            >
                                              Yesterday
                                            </button> */}
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-sm-12">
                            <div style={{ paddingBottom: "60px" }}>
                              <table
                                id="appadmin"
                                className="table table-bordered table-hover dataTable dtr-inline"
                                role="grid"
                                aria-describedby="example2_info"
                              >
                                <thead>
                                  <tr role="row">
                                    <th
                                      className="sorting_asc"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      Asset/Package Name
                                    </th>
                                    <th
                                      className="sorting_asc"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      Type
                                    </th>
                                    <th
                                      className="sorting_asc"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      Amount
                                    </th>
                                    <th
                                      className="sorting"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      Customer Email
                                    </th>
                                    <th
                                      className="sorting"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      Country
                                    </th>

                                    <th
                                      className="sorting"
                                      tabIndex={0}
                                      aria-controls="example2"
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      Created At(UTC)
                                    </th>
                                  </tr>
                                </thead>

                                {sub.SRMSecret && sub.uuid && (
                                  <>
                                    <tbody>
                                      {subs.map((person, index) => (
                                        <tr
                                          role="row"
                                          className="even"
                                          key={index}
                                        >
                                          <td
                                            className="dtr-control sorting_1"
                                            tabIndex={0}
                                          >
                                            {/* <a
                                            href={"#!"}
                                          > */}
                                            {person.item_title}
                                            {/* </a> */}
                                          </td>

                                          <td
                                            className="dtr-control sorting_1"
                                            tabIndex={1}
                                          >
                                            {person.action_type}
                                          </td>

                                          <td
                                            className="dtr-control sorting_1"
                                            tabIndex={1}
                                          >
                                            {person.currency_iso}&nbsp;
                                            {person.charged_amount}
                                          </td>

                                          <td
                                            className="dtr-control sorting_1"
                                            tabIndex={1}
                                          >
                                            {person.consumer_email}
                                          </td>
                                          <td
                                            className="dtr-control sorting_1"
                                            tabIndex={1}
                                          >
                                            {person.country}
                                          </td>

                                          <td
                                            className="dtr-control sorting_1"
                                            tabIndex={1}
                                          >
                                            {formatDate(person.created_at)}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </>
                                )}
                              </table>
                              {!(sub.SRMSecret && sub.uuid) && (
                                <>
                                  <div className="text-center mt-5">
                                    <p className="text-muted">
                                      {" "}
                                      Please Enable Subscription to View Reports
                                    </p>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.card-body */}
                <div className="card-footer text-center">
                  <button
                    onClick={minusNumber}
                    disabled={number === 0 ? true : false}
                  >
                    <i className="fas fa-angle-left "></i>
                  </button>
                  &nbsp;{number}&nbsp;
                  <button
                    onClick={addNumber}
                    disabled={subs.length < 10 ? true : false}
                  >
                    <i className="fas fa-angle-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};

export default SubReport;
